export function setCookie(name: string, val: string) {
  const date = new Date();
  const value = val;

  // Set it expire in 1 days
  date.setTime(date.getTime() + (1 * 1 * 60 * 60 * 1000));

  // Set it
  document.cookie = name + '=' + value + '; expires=' + date.toUTCString() + '; path=/';
}

export function getCookie(name: string): string | null {
  const nameEQ = name + "=";
  const cookies = document.cookie.split(';');
  
  for (let i = 0; i < cookies.length; i++) {
    let c = cookies[i].trim();
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null; // If the cookie is not found
}

export function checkCookie(cookieName: string): boolean {
  // Get all cookies as a string
  const cookies = document.cookie;
  console.log (`cookies ${cookies}`);
  // Check if the cookie exists by looking for the name in the cookies string
  return cookies.split(';').some((cookie) => cookie.trim().startsWith(`${cookieName}=`));
}

export function deleteCookie(name: string) {
  const date = new Date();

  // Set it expire in -1 days
  date.setTime(date.getTime() + (-1 * 24 * 60 * 60 * 1000));

  // Set it
  document.cookie = name + '=; expires=' + date.toUTCString() + '; path=/';
}

export function wait(ms) {
      const start = new Date().getTime();
      let end = start;
      while (end < start + ms) {
        end = new Date().getTime();
    }
}
